import React from 'react';
import { UserPlusIcon, CreditCardIcon, ShoppingBagIcon } from 'lucide-react';
interface HowItWorksProps {
  onOpenModal: () => void;
}
export function HowItWorks({
  onOpenModal
}: HowItWorksProps) {
  const steps = [{
    icon: UserPlusIcon,
    number: '01',
    title: 'Regístrate Gratis',
    description: 'Completa un formulario simple con tus datos básicos. Sin verificación de crédito ni documentos complicados.'
  }, {
    icon: CreditCardIcon,
    number: '02',
    title: 'Recibe Tu Tarjeta',
    description: 'Obtén tu tarjeta digital al instante.'
  }, {
    icon: ShoppingBagIcon,
    number: '03',
    title: 'Comienza a Ahorrar',
    description: 'Presenta tu tarjeta en comercios afiliados y disfruta de tus descuentos y beneficios.'
  }];
  return <section className="bg-gray-900 py-20 px-6" data-id="element-98">
      <div className="max-w-6xl mx-auto" data-id="element-99">
        {/* Section header */}
        <div className="text-center mb-16" data-id="element-100">
          <h2 className="text-4xl md:text-5xl font-bold text-white mb-4" data-id="element-101">
            ¿Cómo{' '}
            <span className="bg-gradient-to-r from-yellow-400 to-yellow-200 bg-clip-text text-transparent" data-id="element-102">
              Funciona?
            </span>
          </h2>
          <p className="text-xl text-gray-400 max-w-2xl mx-auto" data-id="element-103">
            Tres pasos simples para empezar a ahorrar hoy
          </p>
        </div>

        {/* Steps */}
        <div className="grid md:grid-cols-3 gap-8 md:gap-12" data-id="element-104">
          {steps.map((step, index) => {
          const Icon = step.icon;
          return <div key={index} className="relative" data-id="element-105">
                {/* Connector line (hidden on mobile) */}
                {index < steps.length - 1 && <div className="hidden md:block absolute top-16 left-1/2 w-full h-0.5 bg-gradient-to-r from-yellow-600 to-yellow-600/20" data-id="element-106"></div>}

                <div className="relative bg-black border-2 border-yellow-600/30 rounded-xl p-8 hover:border-yellow-600 transition-all" data-id="element-107">
                  {/* Step number */}
                  <div className="absolute -top-6 left-8 text-6xl font-bold text-yellow-600/20" data-id="element-108">
                    {step.number}
                  </div>

                  {/* Icon */}
                  <div className="relative w-16 h-16 bg-gradient-to-br from-yellow-600 to-yellow-500 rounded-full flex items-center justify-center mb-6 mx-auto" data-id="element-109">
                    <Icon className="w-8 h-8 text-black" data-id="element-110" />
                  </div>

                  {/* Content */}
                  <h3 className="text-2xl font-bold text-white mb-3 text-center" data-id="element-111">
                    {step.title}
                  </h3>
                  <p className="text-gray-400 text-center" data-id="element-112">
                    {step.description}
                  </p>
                </div>
              </div>;
        })}
        </div>

        {/* CTA */}
        <div className="mt-16 text-center" data-id="element-113">
          <button onClick={onOpenModal} className="px-10 py-5 bg-gradient-to-r from-yellow-600 to-yellow-500 text-black font-bold text-xl rounded-lg hover:from-yellow-500 hover:to-yellow-400 transition-all transform hover:scale-105 shadow-xl shadow-yellow-600/30" data-id="element-114">
            Comenzar Ahora
          </button>
          <p className="mt-4 text-gray-400" data-id="element-115">
            Únete a miles de usuarios que ya están ahorrando
          </p>
        </div>
      </div>
    </section>;
}